window.currency = (window.currency || {});

const Currency = {
  symbol: window.currency.symbol || '$',
  decimalMark: window.currency.decimal_mark || '.',
  subunitToUnit: window.currency.subunit_to_unit || 100,
  exponent: typeof window.currency.exponent === 'number' ? window.currency.exponent : 2,

  /**
   * Format value to certain currency format
   * @example
   * format(101); => "$1.01"
   * format(-1); => "-$0.01"
   *
   * @param {integer} value the value of cents
   *
   * @return {string}
   */
  format(value, options = {}) {
    const { symbol: optionSymbol = true } = options;

    const [whole, fraction] = this.parts(Math.abs(value));
    let s = value < 0 ? '-' : '';

    s += `${optionSymbol ? this.symbol : ''}` + whole;

    if (fraction) {
      s += this.decimalMark + fraction;
    }

    return s;
  },

  parts(value) {
    const fraction = value % this.subunitToUnit;
    const whole = (value - fraction) / this.subunitToUnit;

    return [`${whole}`, this.exponent ? padvalue(fraction, this.exponent) : null];

    function padvalue(num, size) {
      let s = `${num}`;
      while (s.length < size) {
        s = `0${s}`;
      }
      return s;
    }
  },
};

export default Currency;
